export class ExerciseProgramItemResponseDto {
    id;
    createdAt;
    updatedAt;
    deletedFromProgram;
    exerciseId;
    customIndication;
    performanceType;
    performanceContent;
    setCount;
    pauseDuration;
    weight;
    sortId;
    sortIndex;
    exercise;
}
export class ExerciseProgramResponseDto {
    id;
    createdAt;
    updatedAt;
    version;
    name;
    startDate;
    endDate;
    trainingIsOnMonday;
    trainingIsOnTuesday;
    trainingIsOnWednesday;
    trainingIsOnThursday;
    trainingIsOnFriday;
    trainingIsOnSaturday;
    trainingIsOnSunday;
    userId;
    officeId;
    officeProductAssignmentId;
    index;
    userOfficeId;
    user;
    exerciseProgramItems;
    /**
     * The "Information für den Patienten" message created in *this* create/update
     * operation, if any. Carried on the `exercise-program.created` / `.updated`
     * event payload so the notification listener can link the notification to
     * exactly this message. This is NOT the program's message history — it is only
     * ever the single message just authored (or undefined when none was provided).
     */
    newMessage;
    trainingSessions;
    /** Set by query handler after mapping, not by the mapper itself */
    calendarItem;
    /** Calendar entries for this program in a given timeframe */
    calendarItems;
}
//# sourceMappingURL=exercise-program-response.dto.js.map